import React from 'react';

interface DataTableSkeletonProps {
  rowCount?: number;
  columnCount?: number;
  withCheckbox?: boolean;
  withActions?: boolean;
}

export function DataTableSkeleton({
  rowCount = 5,
  columnCount = 8,
  withCheckbox = true,
  withActions = true,
}: DataTableSkeletonProps) {
  // Calculate total columns including checkbox and actions if needed
  const totalColumns =
    columnCount + (withCheckbox ? 1 : 0) + (withActions ? 1 : 0);

  // Use a fixed array of widths for skeleton cells to avoid hydration errors
  const cellWidths = ['60%', '70%', '80%', '90%', '75%', '85%', '65%', '78%'];

  return (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden will-change-opacity">
      {/* Table Header */}
      <div className="p-4 border-b border-gray-100">
        <div
          className="grid gap-4"
          style={{
            gridTemplateColumns: `${withCheckbox ? '40px ' : ''}repeat(${columnCount}, 1fr)${withActions ? ' 100px' : ''}`,
          }}
        >
          {withCheckbox && (
            <div className="h-6 w-6 bg-gray-200 rounded-md animate-pulse"></div>
          )}

          {[...Array(columnCount)].map((_, i) => (
            <div
              key={i}
              className="h-6 bg-gray-200 rounded-md animate-pulse"
              style={{ width: '90%' }}
            ></div>
          ))}

          {withActions && (
            <div className="h-6 w-16 bg-gray-200 rounded-md animate-pulse ml-auto"></div>
          )}
        </div>
      </div>

      {/* Table Body */}
      {[...Array(rowCount)].map((_, rowIndex) => (
        <div key={rowIndex} className="border-b border-gray-100 p-4">
          <div
            className="grid gap-4"
            style={{
              gridTemplateColumns: `${withCheckbox ? '40px ' : ''}repeat(${columnCount}, 1fr)${withActions ? ' 100px' : ''}`,
            }}
          >
            {withCheckbox && (
              <div className="h-5 w-5 bg-gray-200 rounded-md animate-pulse"></div>
            )}

            {[...Array(columnCount)].map((_, cellIndex) => (
              <div
                key={cellIndex}
                className="h-6 bg-gray-200 rounded-md animate-pulse"
                style={{
                  width: cellWidths[cellIndex % cellWidths.length],
                  animationDelay: `${rowIndex * 0.05 + cellIndex * 0.01}s`,
                }}
              ></div>
            ))}

            {withActions && (
              <div className="flex space-x-2 justify-end">
                <div className="h-8 w-8 bg-gray-200 rounded-full animate-pulse"></div>
                <div className="h-8 w-8 bg-gray-200 rounded-full animate-pulse"></div>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
